import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import { speciesNameWithSynonym } from '../utils/speciesName';
import wantsCol from '../utils/wantsCol';
/**
 * "<i>Accepted name</i> Author (= <i>Synonym name</i> Author)" link to a
 * species' page, used next to discussions (DiscussionListItem) and posts
 * (DiscussionHero) that are tagged with it. Takes already-resolved species
 * data as props (see the `species` field on DiscussionResource) rather than
 * fetching it itself - DiscussionListItem only redraws when its
 * SubtreeRetainer sees a tracked value change, so a child component's own
 * later async fetch would never make it to the DOM.
 *
 * The French vernacular name, when present, shows on its own line right
 * below - same "<span className='...-vernacular'>" convention as
 * DescriptionsPage.js/RandomDescriptions.js. It's only ever populated when
 * the request that fetched this discussion opted in with
 * ?vernacularName=true (see addSpeciesLabels.js's own requestParams
 * extension for the discussion page), so this is a no-op wherever that
 * wasn't requested (species.vernacularName simply comes back undefined).
 */
// The Species::UNDETERMINED_ID/UNDETERMINED_COL_ID sentinels (see that
// second constant's own docblock) - "Non déterminé" has no real GBIF or
// ChecklistBank record of its own, but still only links to its own
// /taxon/:colId address when the actor genuinely prefers COL (same
// wantsCol() gate as every real species below, never unconditionally) -
// GBIF mode and guests keep the plain /species/0 link. Bare literals
// rather than an import from a shared constants module - same lightweight
// convention addSpeciesLabels.tsx's own UNDETERMINED_PSEUDO_SPECIES already
// uses for the matching gbifId.
const UNDETERMINED_ID = 0;
const UNDETERMINED_COL_ID = 'UNDETERMINED';
export default class SpeciesLabel extends Component {
  view() {
    const s = this.attrs.species;
    // See wantsCol()'s own docblock - s.colId is always reported regardless
    // of the actor's preference (extend.php's own `species` field), so this
    // is the only check needed to pick which route to link to. colId falls
    // back to the UNDETERMINED sentinel above for "Non déterminé" (never
    // reported by the API itself, see SpeciesResource's own guard against
    // it), so that one case goes through the exact same wantsCol() check
    // as every other species instead of a separate, unconditional branch.
    const colId = s.gbifId === UNDETERMINED_ID ? UNDETERMINED_COL_ID : s.colId;
    // pageSlug, not canonicalName, for the species page: the page's own
    // canonical URL never carries this discussion's "cf."/"sp."/"s.l."
    // wording (speciesSlug() leaves an already-slugged value unchanged).
    const href = colId && wantsCol() ? app.route.taxon(colId, s.canonicalName) : app.route.species(s.gbifId, s.pageSlug || s.canonicalName);
    return m(Link, {
      className: "SpeciesLabel",
      href: href,
      onclick: e => e.stopPropagation()
    }, speciesNameWithSynonym(s), s.vernacularName && m("span", {
      className: "SpeciesLabel-vernacular"
    }, s.vernacularName));
  }
}
flarum.reg.add('champis-species', 'forum/components/SpeciesLabel', SpeciesLabel);